import isNumber from 'lodash/isNumber'

import { buildLiability } from './formActions'

export const submitForm = async (state, formValues) => {
  const { formLiabilityType, liabilityId, crudActions } = state
  const newLiability = buildLiability(formValues, formLiabilityType)
  const isCreatingNewLiability = creatingNewLiability(state)

  if (isCreatingNewLiability) {
    await crudActions.create(newLiability)
  } else {
    await crudActions.update({ ...newLiability, id: liabilityId })
  }
}

export const deleteLiability = async (state) => {
  const { crudActions } = state

  await crudActions.delete(state.liability.id)
}

const creatingNewLiability = (state) =>
  !isNumber(state.liabilityIndex)
